module.exports = __webpack_public_path__ + "static/media/recording.775cbdac.svg";